import React from "react";

import ListWrapper from "../../../common/management/ListWrapper";
import ListContentWrapper from "../../../common/management/ListContentWrapper";
import ReleaseTopicsList from "../../management-jikei/release-list/ReleaseTopicsList";

import { useAppSelector } from "../../../redux/hooks";
import { getAuthToken } from "../../../redux/reducers/auth";

import { genDisplayCount } from "../../../utils/GeneralUtils";
import { PageVisibility } from "../../../utils/PageVisibility";
import { useGetTopicsAdmin } from "../../../utils/useTopics";

type Props = {
  currentPage: number;
  perView: number;
  sortBy?: string;
};
const ReleaseTopicsContainer: React.FC<Props> = ({
  currentPage,
  perView,
  sortBy,
}) => {
  const auth_token = useAppSelector(getAuthToken);

  const {
    topicsData: {
      items: topics,
      authors,
      total_entries: entries,
      total_pages: totalPage,
    },
    isLoading,
  } = useGetTopicsAdmin({
    auth_token,
    status: PageVisibility.AwaitingInspection,
    per: perView,
    page: currentPage,
    sort_by: sortBy,
    desc: sortBy == "_id" ? true : false,
  });

  return (
    <ListWrapper pageTitle="トピックス公開申請">
      <ListContentWrapper
        isLoading={isLoading}
        displayCount={genDisplayCount(currentPage, totalPage, perView, entries)}
        totalEntries={entries}
        currentPage={currentPage}
        totalPage={totalPage}
      >
        <ReleaseTopicsList topics={topics} authors={authors} />
      </ListContentWrapper>
    </ListWrapper>
  );
};

export default ReleaseTopicsContainer;
